import { Typography } from "antd";
import FilterMenu from "components/CustomFilterMenu/FilterMenu";
import { useGetManufacturers } from "hooks/manufacturer/manufacturer";
import { useGetProducts } from "hooks/product/product";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { formatCurrency } from "utils/helperFuncs";
import { arrayUniqueByKey } from "utils/object";
import FilterInStock from "../FilterStock";

const useList = ({ params, onTableChange, onSelected, handleFilter, selectedProduct }) => {
  const { data: products, paginationData, loading } = useGetProducts(params);
  const { dataManufactures: manufacturersOptions } = useGetManufacturers();

  const onChange = (pagination) => {
    onTableChange && onTableChange(pagination);
  };

  const onFilter = (key, value) => {
    if (key === "realStocks") {
      const realStocksFilter = arrayUniqueByKey(
        [...(params?.filters?.realStocks ? params?.filters?.realStocks : []), value],
        "warehouseID"
      ).filter((item) => item?.range?.from || item.range?.to);

      handleFilter && handleFilter(key, realStocksFilter);
    } else {
      handleFilter && handleFilter(key, value);
    }
  };

  const columns = [
    {
      title: t("cart.productInformationColumn"),
      align: "center",
      render: (text, record, index) => (
        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Typography.Link style={{ textAlign: "start", margin: 0 }}>
            <Link to={`/product/detail/${record?.id}`} target="_blank">
              <Typography.Link strong> {record?.code}</Typography.Link>
            </Link>
          </Typography.Link>
          <Typography.Text style={{ textAlign: "start", margin: 0 }} strong>
            {record?.name}
          </Typography.Text>
          <Typography.Text style={{ textAlign: "end", margin: 0 }} italic>
            {record?.uom?.name}
          </Typography.Text>
        </div>
      ),
      width: 500,
    },
    {
      title: t("product.tableTitle.producer"),
      render: (text, record, index) => <Typography.Text>{record?.manufacturer?.name}</Typography.Text>,
      ...(!selectedProduct?.isFilterSelected && {
        filterDropdown: (
          <FilterMenu
            onFilter={(value) => onFilter("manufacturerIDs", value)}
            type="checkbox"
            options={manufacturersOptions}
          />
        ),
      }),
    },
    {
      title: t("product.tableTitle.price"),
      align: "end",
      render: (text, record, index) => (
        <Typography.Text>{formatCurrency(record?.priceOfSeller?.price)}</Typography.Text>
      ),
    },
    {
      title: t("product.tableTitle.inStock"),
      align: "center",
      render: (text, record, index) => (
        <Typography.Text>
          {record?.stocks?.length
            ? Math.min(
                record.stocks[0]?.quantityRealStockHasVat ?? 0,
                record.stocks[0]?.quantity ?? 0
              )
            : ""}
        </Typography.Text>
      ),
      ...(!selectedProduct?.isFilterSelected && {
        filterDropdown: <FilterInStock warehouseIDs={params?.warehouseIDs} onFilter={onFilter} />,
      }),
    },
    {
      title: "LOẠI % VAT",
      dataIndex: "vatPercent",
      align: "center",
      width: 120,
      render: (_, record) => {
        return <div>{record?.vatPercent >= 0 ? `${record?.vatPercent}%` : "KCT"}</div>;
      },
      editable: "true",
    },
  ];

  const onSelectedRows = (selectedRowKeys, selectedRows) => {
    onSelected && onSelected(selectedRowKeys, selectedRows);
  };

  return { columns, products, paginationData, onChange, loading, onSelectedRows };
};

export default useList;
